/**
 * This file was generated by:
 *   relay-compiler
 *
 * @providesModule AddCartItemMutation.graphql
 * @generated SignedSource<<ada58ce9e72c921dc9766d572c8346e7>>
 * @relayHash dd85178d55dcaee6f48cacbe8c593036
 * @flow
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddCartItemInput = {
  itemIds?: ?string;
};

export type AddCartItemMutationResponse = {
  portfolioItems?: ?Array<?AddCartItemMutationResponse_portfolioItems>;
};

export type AddCartItemMutationResponse_portfolioItems_item = {
  itemId?: ?string;
};

export type AddCartItemMutationResponse_portfolioItems = {
  item?: ?AddCartItemMutationResponse_portfolioItems_item;
};
*/


/*
mutation AddCartItemMutation(
  $input: AddCartItemInput!
) {
  addCartItem(input: $input) {
    portfolioItems {
      item {
        itemId
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AddCartItemInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddCartItemMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AddCartItemInput!"
          }
        ],
        "concreteType": "AddCartItemPayload",
        "name": "addCartItem",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioItemV1",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemSummary",
                "name": "item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "itemId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddCartItemMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "AddCartItemInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AddCartItemMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "AddCartItemInput!"
          }
        ],
        "concreteType": "AddCartItemPayload",
        "name": "addCartItem",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioItemV1",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemSummary",
                "name": "item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "itemId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation AddCartItemMutation(\n  $input: AddCartItemInput!\n) {\n  addCartItem(input: $input) {\n    portfolioItems {\n      item {\n        itemId\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/AddCartItemMutation.graphql.js